<script lang="ts" setup>
import type { BaseContentResponseModel } from '@su4r-frontend/api';

const { locale } = useI18n();
const { setLayout, currentLayout } = useLayout();
const route = useRoute();
const path = useResolvePathFromSlug();
const setI18nParams = useSetI18nParams();

definePageMeta({
    layout: false,
});

const { data, error } = await useFetch<BaseContentResponseModel>(`/api/content/${path}`, {
    key: route.fullPath,
    query: {
        culture: locale.value,
    },
});

if (error.value) {
    throw createError({
        statusCode: error.value.status,
        statusMessage: error.value.message,
        fatal: true,
        message: error.value.message,
    });
}

if (data.value?.type === 'prescription' || data.value?.type === 'patientOrder') {
    setLayout('prescription');
} else {
    setLayout('default');
}

const translatedSlugs = data.value?.cultures
    ? Object.fromEntries(
          Object.entries(data.value?.cultures).map(([key, value]) => {
              const path = value.path || '';
              // Remove first and last slashes and split by slashes to create an array like ['blogs', 'my-first-blog'] from '/blogs/my-first-blog/'
              const slug = path === '/' ? [''] : path.replace(/^\/|\/$/g, '').split('/');
              return [key, { slug }];
          })
      )
    : {};

setI18nParams(translatedSlugs);

useSeoMeta({
    title: () => data.value?.name ?? '',
    ogTitle: () => data.value?.name ?? '',
    description: () => data.value?.metaInformation?.metaDescription,
    ogDescription: () => data.value?.metaInformation?.metaDescription,
    ogImage: () => data.value?.metaInformation?.imageUrl,
});

const component = computed(() => mapToView(data.value?.type ?? ''));
</script>

<template>
    <div>
        <NuxtLayout v-if="data" :name="currentLayout">
            <component :is="component" :data />
        </NuxtLayout>
    </div>
</template>
